var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-header"},[_c('img',{attrs:{"src":require("@/assets/img/logo.png"),"alt":""}}),_c('div',{staticClass:"header-right"},[_c('span',{staticClass:"name"},[_vm._v("智蛛AI")]),_c('span',[_vm._v("有“智”者，事竟成")])])])
}]

export { render, staticRenderFns }